<template>
  <div :class="[bem.b()]">
    <ll-select
      v-model:value="selectValue"
      :size="size"
      placeholder="请选择"
      :style="{
        minWidth: addUnit(minWidth),
        maxWidth: maxWidth ? addUnit(maxWidth) : undefined,
      }"
      :options="options"
      :field-names="fieldNames"
      :class="bem.e('select-content')"
      @select="handleSelect"
    />
    <!-- 排序 -->
    <ll-button
      :class="[bem.e('sort-btn')]"
      type="text"
      :size="size"
      @click="handleSort"
    >
      <template #icon>
        <ll-icon-base
          :arrow="true"
          :is-white-bg="false"
          :is-show-container="false"
          :tooltip-title="
            sortValue === 'asc' ? ascText || '升序' : descText || '降序'
          "
          :icon-name="
            sortValue === 'asc' ? 'icon-ascending' : 'icon-descending'
          "
        />
      </template>
    </ll-button>
  </div>
</template>

<script setup lang="ts">
import { addUnit, createNamespace } from '@ll-plus/utils'
import { computed, onMounted } from 'vue'
import { sortSelectorProps } from './sort-selector'

defineOptions({ name: 'LlSortSelector' })

const bem = createNamespace('sort-selector')

const props = defineProps(sortSelectorProps)
const emits = defineEmits(['change', 'update:selectValue', 'update:sortValue'])

const selectValue = computed({
  get: () => props.selectValue || props.options?.[0]?.value || null,
  set: (val: any) => {
    emits('update:selectValue', val)
  },
})

const sortValue = computed({
  get: () => props.sortValue || props.options?.[0]?.orderBy || 'asc',
  set: (val: string) => {
    emits('update:sortValue', val)
  },
})

// 处理字段切换
// const handleSelect = (_, option) => {
//   sortValue.value = option.orderBy || 'asc'
// }

// // 处理排序方向切换
// const handleSort = () => {
//   sortValue.value = sortValue.value === 'asc' ? 'desc' : 'asc'
// }

// 处理字段切换
const handleSelect = (value, option) => {
  const newSelectVal = value
  const newSortVal = option.orderBy || 'asc'

  selectValue.value = newSelectVal
  sortValue.value = newSortVal

  // 统一在这里触发一次 change 事件
  emits('change', newSelectVal, newSortVal)
}

// 处理排序方向切换
const handleSort = () => {
  const newSortVal = sortValue.value === 'asc' ? 'desc' : 'asc'
  sortValue.value = newSortVal
  emits('change', selectValue.value, newSortVal)
}

onMounted(() => {
  if (!props.selectValue && props.options?.length > 0) {
    emits('update:selectValue', props.options[0]?.value || '')
  }
  if (!props.sortValue) {
    emits('update:sortValue', props.options[0]?.orderBy || 'asc')
  }
})
</script>
